module.exports = __webpack_public_path__ + "v294910/img/ai doctor.68e04033.png";